import React from "react";
import { Container, Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import Header from "components/Headers/Header.js";
import imgPhotoA from '../assets/img/photoa.jpg';
import imgPhotoB from '../assets/img/photob.png';
import imgBigLogo from '../assets/img/logo-big.png';

const About = () => {
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col md="12">
            <Card className="shadow">
              <CardHeader className="text-left">
                <img
                  src={imgBigLogo}
                  alt="Bolton Potholes BirdNet Station"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
              </CardHeader>
              <CardBody>
                <Row className="align-items-center mb-4">
                  <Col xs="12" md="6" className="mb-3 mb-md-0">
                    <img
                      src={imgPhotoA}
                      alt="Bolton Potholes Waterfall"
                      className="img-fluid rounded shadow w-100"
                    />
                  </Col>
                  <Col xs="12" md="6">
                    <p>
                      The <strong>Bolton Potholes BirdNet Station</strong> is a citizen science project
                      located along Joiner Brook in the Green Mountains of Vermont, just uphill from the
                      popular Bolton Potholes swimming area.
                    </p>
                    <p>
                      Bolton Potholes info:&nbsp;<br />
                      <a href="https://vermontriverconservancy.org/sites/bolton-potholes" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-leaf mr-1 text-success"></i>Vermont River Conservancy
                      </a>{" "}
                      |{" "}
                      <a href="https://g.co/kgs/hVmUs5N" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-map-marker-alt mr-1 text-danger"></i>Google Maps
                      </a>{" "}
                      |{" "}
                      <a href="https://www.instagram.com/explore/locations/5315955/bolton-potholes/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-instagram mr-1 text-purple"></i>Instagram
                      </a>
                    </p>
                  </Col>
                </Row>

                <Row className="align-items-center mb-4">
                  <Col xs="12" md="6" className="order-2 order-md-1">
                    <p>
                      This system runs continuously, using the <a href="https://birdnet.cornell.edu/" target="_blank" rel="noopener noreferrer">BirdNET</a> model developed by the Cornell Lab of Ornithology to identify bird species by their songs and calls.
                      It captures and analyzes audio in (near) real time, logging bird detections and providing insights into seasonal and daily bird activity.
                    </p>
                    <p>
                      Additionally, all of the weather data is collected from a nearby personal weather station.
                    </p>
                    <p>
                      This page is really just here to share it with you! Friends, family and visitors alike. Thanks for checking it out. -Doug
                    </p>
                  </Col>
                  <Col xs="12" md="6" className="order-1 order-md-2 mb-3 mb-md-0">
                    <img
                      src={imgPhotoB}
                      alt="Joiner Brook upstream"
                      className="img-fluid rounded shadow w-100"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default About;
